import {AnalyticsEventHandler} from "../../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {FOOTER_MODULE} from "../footer-module.consts";
import {Type} from "../../../../../infrastructure/type";
import {FooterModuleStoreClickEvent} from "../models/footer-module.store-click-event";

export class FooterModuleStoreClickEventHandler extends AnalyticsEventHandler {
  type: string = FOOTER_MODULE.ACTION_TYPES.storeClick;
  eventType: Type = FooterModuleStoreClickEvent;

  static injectables = [AnalyticsService];
}
